import { useQuery } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getCustomerOrderFeedbackQuestions,
  type OrderFeedbackQuestionType,
} from '@hungryroot/rest/api/v2/customers/[id]/order_feedback_questions/get/get-customer-order-feedback-questions';

export const getOrderQueryKey = (type: OrderFeedbackQuestionType) => [
  'Customer',
  'Order Feedback Question',
  type,
];

export const useOrderFeedbackQuestion = ({
  type,
  enabled = true,
}: {
  type: OrderFeedbackQuestionType;
  enabled?: boolean | undefined;
}) => {
  const timeLimit = 5 * 60 * 1000;
  return useQuery({
    queryKey: getOrderQueryKey(type),
    queryFn: async () => {
      const response = await getCustomerOrderFeedbackQuestions({ type });

      if (response.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(response.data, null, 2));
      }

      return response.data;
    },
    gcTime: timeLimit,
    staleTime: timeLimit,
    enabled,
  });
};
